import axios from 'axios'

export class GravatarService {
	
	public async exists(gravatarId: string): Promise<any> {
		return axios.get(`https://fr.gravatar.com/${gravatarId}.json`)
	}
}